"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceActionsService = void 0;
const tslib_1 = require("tslib");
const DEVICE_ACTIONS_API_VERSION = 'v1';
class DeviceActionsService {
    constructor(deviceUrlsBase, request) {
        this.request = request;
        this.startAction = ({ uuid, actionName, params, extraOptions, }) => this.makeActionRequest({
            method: 'POST',
            uuid,
            actionNameOrId: actionName,
            params,
            extraOptions,
        });
        this.getActionStatus = ({ uuid, actionId, extraOptions, }) => this.makeActionRequest({
            method: 'GET',
            uuid,
            actionNameOrId: actionId,
            extraOptions,
        });
        this.makeActionRequest = ({ method, uuid, actionNameOrId, params, extraOptions, }) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = params ? { parameters: params } : null;
            const { body } = yield this.request.send(Object.assign({ method, url: `${this.actionsEndpoint}/${uuid}/${actionNameOrId}`, body: data }, extraOptions));
            return body;
        });
        this.actionsEndpoint = `https://actions.${deviceUrlsBase}/${DEVICE_ACTIONS_API_VERSION}`;
    }
}
exports.DeviceActionsService = DeviceActionsService;
